// TutorsLinks Educator Impact Challenge 2026 — mirrors
// tutorslinks-backend/config/challenge.js. Kept in sync by hand since the
// two apps don't share code.
export const CHALLENGE_SUBMISSION_DEADLINE = "2026-10-31T23:59:59+01:00";
export const CHALLENGE_GRAND_FINALE = "2026-11-28T00:00:00+01:00";

export const CHALLENGE_MAX_VIDEO_BYTES = 10 * 1024 * 1024; // 10MB
export const CHALLENGE_MAX_VIDEO_SECONDS = 3 * 60; // 3 minutes

export const SOCIAL_PLATFORMS = ["Facebook", "Instagram", "TikTok", "LinkedIn"];

export const BIO_MIN_WORDS = 150;
export const BIO_MAX_WORDS = 250;
